import { useMemo } from 'react'

import { Alert } from 'antd'

import EntitiesSelector from './EntitiesSelector'

const SectorSelector = ({ className = '', disabled, loading, notice, placeholder, sectors, style = {}, values, onChange }) => {
  const options = useMemo(() => sectors.map(s => ({
    label: s.name,
    value: s.id,
    tooltip: s.name,
    entity: s
  })), [sectors])

  const renderDropdown = menu => (
    <div>
      <Alert className='dropdown-notice' message={notice} type='info' showIcon banner />
      {menu}
    </div>
  )

  return (
    <EntitiesSelector
      disabled={disabled}
      dropdownRender={notice ? renderDropdown : undefined}
      entityOptions={options}
      loading={loading}
      multiple='default'
      placeholder={placeholder}
      selectorClassName={className}
      tagPlaceholder={false}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default SectorSelector
